import React, {PureComponent} from 'react';
import LoadingIcon from 'Components/icons/LoadingIcon';
import logo from 'Images/logo_bottom.png';
import {T} from 'Actions/translate';

class Rotate extends PureComponent {
    render() {
        const {showLoadingMore, showAbyss} = this.props;
        return (
            <div>
                {showLoadingMore ? (
                    <div className="landing-bottom">
                        <LoadingIcon className="spinner" />
                        <span className="loading">{T('loading')}</span>
                    </div>
                ) : null}
                {showAbyss ? (
                    <div className="abyss-sect">
                        <div className="hr-sect">
                            <span className="finish-line">
                                {T('already_in_the_bottom')}
                            </span>
                        </div>
                        <div className="image-sect">
                            <img src={logo} className="logo" alt="tfc logo" />
                        </div>
                        <div className="record-number">
                            <a href="https://beian.miit.gov.cn/">
                                {T('record_number')}
                            </a>{' '}
                            |
                            <a href="//www.thermofisher.com/cn/zh/home/global/licenses-cn.html">
                                {' '}
                                {T('business_license')}
                            </a>
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

export default Rotate;
